import { queryOptions, useQuery } from '@tanstack/react-query'

import { apiClient } from '@/apiClient.ts'

export interface UseGetEventArgs {
  eventId: string
}

export const getEventQueryOptions = (args: UseGetEventArgs) =>
  queryOptions({
    queryKey: ['events', args.eventId],
    queryFn: () =>
      apiClient.calendar.events[':eventId']
        .$get({ param: { eventId: args.eventId } })
        .then(async (r) => r.json()),
  })

export const useGetEvent = (
  args: UseGetEventArgs,
  options?: Partial<ReturnType<typeof getEventQueryOptions>>
) =>
  useQuery({
    ...getEventQueryOptions(args),
    ...options,
  })
